/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as Sentry from '@sentry/browser';
export let isLocalStorageAvailable = false;
export const LocalStorage = {
  get(key) {
    let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (!isLocalStorageAvailable) {
      return;
    }
    const serializedStore = localStorage.getItem(key);
    if (!serializedStore) {
      return defaultValue;
    }
    try {
      const store = JSON.parse(serializedStore);
      const now = Date.now();
      if (store.expiredAt !== -1 && now >= store.expiredAt) {
        this.remove(key);
        return defaultValue;
      }
      return store.value;
    } catch (e) {
      Sentry.captureException(e);
    }
  },
  remove(key) {
    if (!isLocalStorageAvailable) {
      return;
    }
    localStorage.removeItem(key);
  },
  // optionally accept a ttl in milliseconds
  set(key, value, ttl) {
    if (!isLocalStorageAvailable) {
      return;
    }
    const store = {
      createdAt: Date.now(),
      expiredAt: ttl ? Date.now() + ttl : -1,
      key,
      value
    };
    try {
      window.localStorage.setItem(key, JSON.stringify(store));
    } catch (e) {
      Sentry.captureException(e);
    }
  }
};
export const checkBrowserSupport = () => {
  const test = 'test';
  try {
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    isLocalStorageAvailable = true;
  } catch (e) {
    isLocalStorageAvailable = false;
  }
  return isLocalStorageAvailable;
};
checkBrowserSupport();